export default __webpack_public_path__ + "static/media/p2.1bbae2a1.jpg";